export default function InfoIcon() {
    return (
        <svg enableBackground="new 0 0 64 64" version="1.1" viewBox="0 0 64 64">
            <path d="m38.535 47.606h-4.0801v-19.159c0-0.5527-0.4473-1-1-1h-4.5205c-0.55231 0-1 0.4473-1 1s0.44769 1 1 1h3.5205v18.159h-5.1216c-0.5522 0-1 0.4472-1 1 0 0.5527 0.4478 1 1 1h11.202c0.5527 0 1-0.4473 1-1 0-0.5528-0.4473-1-1-1z" />
            <circle cx="32" cy="18" r="3" />
            <path d="m32 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 62c-16.542 0-30-13.458-30-30 0-16.542 13.458-30 30-30s30 13.458 30 30c0 16.542-13.458 30-30 30z" />
        </svg>
    );
}